import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import CodeIcon from '@mui/icons-material/Code';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import LanguageIcon from '@mui/icons-material/Language';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import CloudIcon from '@mui/icons-material/Cloud';
import BrushIcon from '@mui/icons-material/Brush';
import './ServicesDropdown.css';

const serviceCategories = [
  {
    title: 'Software Development',
    icon: <CodeIcon />,
    path: '/services/software-development'
  },
  {
    title: 'Mobile Apps',
    icon: <PhoneIphoneIcon />,
    path: '/services/mobile-apps'
  },
  {
    title: 'Web Development',
    icon: <LanguageIcon />,
    path: '/services/web-development'
  },
  {
    title: 'AI & Automation',
    icon: <SmartToyIcon />,
    path: '/services/ai-automation'
  },
  {
    title: 'Cloud Solutions',
    icon: <CloudIcon />,
    path: '/services/cloud-solutions'
  },
  {
    title: 'UI/UX Design',
    icon: <BrushIcon />,
    path: '/services/ui-ux-design'
  }
];

const ServicesDropdown = ({ isOpen }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="services-dropdown"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.2 }}
        >
          <Box className="services-content">
            {serviceCategories.map((category, index) => (
              <motion.div
                key={category.title}
                className="service-category"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05 }}
              >
                <Link to={category.path} className="service-link">
                  <Box className="category-header">
                    {React.cloneElement(category.icon, { className: 'category-icon' })}
                    <Typography className="service-category-title">
                      {category.title}
                    </Typography>
                  </Box>
                </Link>
              </motion.div>
            ))}
          </Box>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ServicesDropdown; 